import React from "react";
import { ArrowRight, Sparkles, SprayCan, Car } from "lucide-react";

const OFFERS = [
  { icon: SprayCan, label: "Exterior" },
  { icon: Sparkles, label: "Interior" },
  { icon: Car, label: "Full Detail" },
];

export const Services = ({ onBookService }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-[#4B0082] font-semibold mb-4">
            Our offers
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-slate-900 leading-tight">
            Book your next detail.
          </h2>
        </div>

        <button
          type="button"
          onClick={() => onBookService(null)}
          data-testid="our-offers-card"
          className="group w-full text-left bg-white border border-slate-200 rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-2xl hover:border-[#4B0082]/40 transition-all duration-300"
        >
          <div className="grid lg:grid-cols-5 gap-0">
            <div className="lg:col-span-3 p-8 lg:p-12">
              <p className="text-slate-600 text-base sm:text-lg leading-relaxed mb-8">
                Choose from three packages — pick the one that fits your car
                and your day. Prices revealed in the booking step.
              </p>

              <div className="space-y-3 mb-10">
                {OFFERS.map((o, i) => (
                  <div
                    key={o.label}
                    data-testid={`offer-preview-${o.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="flex items-center gap-4 p-4 rounded-lg bg-slate-50 group-hover:bg-[#F3E8FF]/50 transition-colors"
                  >
                    <div className="w-11 h-11 rounded-md bg-white border border-slate-200 flex items-center justify-center flex-shrink-0">
                      <o.icon className="w-5 h-5 text-[#4B0082]" />
                    </div>
                    <div className="flex-1">
                      <div className="font-heading font-semibold text-slate-900">
                        {o.label}
                      </div>
                    </div>
                    <div className="text-xs uppercase tracking-widest text-slate-400 font-medium">
                      0{i + 1}
                    </div>
                  </div>
                ))}
              </div>

              <div className="inline-flex items-center gap-2 text-[#4B0082] font-semibold text-base group-hover:gap-3 transition-all">
                Start booking
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </div>
            </div>

            <div className="lg:col-span-2 bg-[#0F172A] p-8 lg:p-12 flex flex-col justify-between text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-72 h-72 bg-[#4B0082]/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3" />

              <div className="relative">
                <div className="text-xs uppercase tracking-[0.3em] text-[#C4A6F0] font-semibold mb-3">
                  How it works
                </div>
                <h3 className="font-heading font-bold text-2xl sm:text-3xl tracking-tight leading-tight mb-6">
                  One tap. Three options. Done.
                </h3>
                <ul className="space-y-3 text-white/80 text-sm">
                  <li className="flex gap-3">
                    <span className="font-heading font-bold text-[#C4A6F0]">1.</span>
                    <span>Pick a package in the next step</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-heading font-bold text-[#C4A6F0]">2.</span>
                    <span>Choose a date & time that works</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-heading font-bold text-[#C4A6F0]">3.</span>
                    <span>We come to you, anywhere in Northern Utah</span>
                  </li>
                </ul>
              </div>

              <div
                className="relative mt-10 inline-flex items-center justify-center gap-2 bg-white text-[#4B0082] font-semibold px-6 py-3.5 rounded-md group-hover:bg-[#F3E8FF] transition-colors"
              >
                Book a Detail
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </div>
        </button>
      </div>
    </section>
  );
};
